import React from "react";
import "./homePage.style.sass";
import DrawerNav from "../../components/drawer/drawer.component";
import AdvantageStrip from "../../components/advantageStrip/advantageStrip.component";
import SamanehWeb from "../../components/samanehWeb/samanehWeb.component";
import CountUpComponent from "../../components/countUp/countUp.component";
import Products from "../products/products.component";
import CityPic from "../../components/cityPicture/city-pic.component";
import NewsComponent from "../../components/news/news.component";
import BannersComponent from "../../components/banner/banner.component";
import CompanisComponent from "../../components/companis/companis.component";

class HomePage extends React.Component {
  render() {
    return (
      <div className="home-page">
        <AdvantageStrip />
        <SamanehWeb />
        <CountUpComponent />
        <Products />
        <BannersComponent />
        {/* <CityPic /> */}
        <DrawerNav />
        <NewsComponent news={true} />
        <CompanisComponent />
      </div>
    );
  }
}

export default HomePage;
